import { IconType } from "react-icons/lib";
import { TbCar, TbChecks } from "react-icons/tb";

import { CommonFilterSwitch } from "@/pages/Plannn/types";

import { softColors } from "./colors";

export type DriverStatusFilterItem = {
    component: () => IconType;
    hover: string;
    bg: string;
    label: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
    value: CommonFilterSwitch;
};

export type DriverStatusFilterList = DriverStatusFilterItem[];

export const driverStatusFilters: DriverStatusFilterList = [
    {
        label: "Çalışıyor",
        component: () => TbCar,
        ...softColors.green,
        tooltip: {
            title: "driverStatuses.WORKING",
            description: "driverStatuses.WORKING_DESC",
        },
        value: CommonFilterSwitch.TRUE,
    },
    {
        label: "Çalışmıyor",
        component: () => TbChecks,
        ...softColors.amber,
        tooltip: {
            title: "Kullanıcı Mesaide Değil",
            description: "Kullanıcı aktif değil, mesaide değil.",
        },
        value: CommonFilterSwitch.FALSE,
    },
];
